/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import MuiDialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Search from '../home/Search';

export default function SearchModal({ open, onClose }) {
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      css={css`
        .MuiDialog-container {
          align-items: flex-start;
        }
      `}
      PaperProps={{
        sx: {
          borderRadius: '8px',
        },
      }}
    >
      <DialogContent
        css={css`
          padding: 0 8px;
          background: var(--background);
        `}
      >
        <Search maxWidth="600px" />
      </DialogContent>
    </MuiDialog>
  );
}
